import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import axiosService from '../../../../../utils/AxiosService'
import CountrySelect from '../../../../FormComponents/CountrySelect'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import Modal from '../../../../Modal/Modal'
import * as Yup from 'yup'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'

const CountrySchema = Yup.object().shape({ country: Yup.string().required('This field is required.') })

export default observer(function CountryModal({ authentication, setIsOpen, isOpen }) {
  const { id } = useParams()
  const influencerContext = useContext(InfluencerContext)

  const handleSubmit = ({ country }) => {
    axiosService.patch(`/api/project_manager/authentications/${id}`, { authentication: { country } })
    .then(updatedAuthentication => {
      const accounts = influencerContext?.authentications?.length ? influencerContext.authentications : [authentication]
      accounts.forEach(account => {
        account.country = updatedAuthentication.country
        account.country_locked = !!updatedAuthentication.country
      })
      toastSuccess(accounts.length > 1 ? 'Country updated on all accounts of this creator' : 'Country updated successfully')
      setIsOpen(false)
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Header>Edit Country</Modal.Header>
      <Modal.Body>
        <div className="w-half-screen">
          <Formik
            initialValues={{
              country: authentication.country,
            }}
            validationSchema={CountrySchema}
            onSubmit={handleSubmit}
          >
            {({ handleBlur, values, setFieldValue, errors, touched }) => (
              <Form>
                <div className="form-item-container w-full">

                  <CountrySelect error={touched.country && errors.country} label="Country" name="country" onChange={value => setFieldValue('country', value?.value, true)} onBlur={handleBlur} value={values.country}/>
                  <button
                    type="submit"
                    className="submit text-left w-full text-rb-green border-2 rounded-full w-60 py-4 text-center active:shadow-outer active:shadow-rb-green border-rb-green"
                  >
                    Update
                  </button>

                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  )
})